<template>
  <div>
    <b-modal
      v-model="showModal"
      ref="alertModal"
      hide-header
      hide-footer
      centered
      size="md"
    >
      <div class="modal-header ">
        <div class="d-flex justify-content-between w-100">
          <div class="py-2">
            <h4>Reset Password</h4>
          </div>
          <button type="button" aria-label="Close" class="btn " @click="hide">
            <font-awesome-icon icon="times" title="Delete" />
          </button>
        </div>
      </div>
      <div class="">
        <b-row>
          <b-col>
            <InputText
              textFloat="New Password"
              placeholder="New Password"
              type="password"
              name="password"
              textWarning="(รหัสผ่านจำเป็นจะต้องมีตัวเลขและตัวอักษรรวมกันอย่างน้อย 8 ตัว)"
              isRequired
              v-model="form.password"
              :isValidate="$v.form.password.$error"
              :v="$v.form.password"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <InputText
              textFloat="Confirm New Password"
              placeholder="Confirm New Password"
              type="password"
              name="password"
              isRequired
              v-model="form.confirmPassword"
              :isValidate="$v.form.confirmPassword.$error"
              :v="$v.form.confirmPassword"
            />
          </b-col>
        </b-row>

        <b-row class="mt-4">
          <b-col md="6">
            <b-button
              :disabled="isDisable"
              @click="hide()"
              class="btn-details-set btn-cancel"
              >CANCEL</b-button
            >
          </b-col>
          <b-col md="6" class="text-sm-right">
            <button
              type="button"
              @click="checkForm()"
              :disabled="isDisable"
              class="btn btn-main btn-details-set ml-md-2 text-uppercase"
            >
              SUBMIT
            </button>
          </b-col>
        </b-row>
      </div>
      <ModalAlert
        ref="modalAlert"
        :text="modalMessage"
        v-on:hadleModalAlertClose="hadleModalAlertClose"
      />
      <ModalAlertError ref="modalAlertError" :text="modalMessage" />
      <ModalLoading ref="modalLoading" :hasClose="false" />
    </b-modal>
  </div>
</template>

<script>
import {
  required,
  integer,
  minLength,
  requiredIf,
  email,
  helpers,
  sameAs
} from "vuelidate/lib/validators";

const password = helpers.regex(
  "password",
  /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9!-_]+)$/
);
import InputText from "@/components/inputs/InputText";
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import ModalLoading from "@/components/modal/alert/ModalLoading";

export default {
  components: {
    InputText,
    ModalAlert,
    ModalAlertError,
    ModalLoading
  },
  props: {
    userData: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      showModal: false,
      modalMessage: "",
      isDisable: false,
      form: {
        userGUID: "",
        password: "",
        confirmPassword: ""
      }
    };
  },
  validations: {
    form: {
      password: {
        required,
        password,
        minLength: minLength(8)
      },
      confirmPassword: {
        required,
        password,
        minLength: minLength(8),
        sameAsPassword: sameAs("password")
      }
    }
  },
  methods: {
    hadleModalAlertClose() {
      this.hide();
    },
    checkForm: async function() {
      this.form.userGUID = this.userData.userGUID;
      this.$v.form.$touch();
      if (this.$v.form.$error) return;
      this.submit();
    },
    submit: async function() {
      this.isDisable = true;
      this.$refs.modalLoading.show();
      let data = {
        userGUID: this.form.userGUID,
        password: this.form.password
      };
      await this.axios
        .post(`${this.$baseUrl}/user/ResetPassword`, data)
        .then(data => {
          if (data.result == 1) {
            this.redirecId = data.detail;
            this.modalMessage = "สำเร็จ";
            this.$refs.modalLoading.hide();
            this.$refs.modalAlert.show();
            this.$emit("setNewPassword", this.form.password);
          } else {
            this.modalMessage = data.message;
            this.$refs.modalLoading.hide();
            this.$refs.modalAlertError.show();
          }
          this.isDisable = false;
        });
    },
    show() {
      this.form = {
        userGUID: "",
        currentPassword: "",
        newPassword: ""
      };
      this.$v.form.$reset();
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    }
  }
};
</script>

<style scoped>
.modal-header {
  border: 0 !important;
  padding: 0;
}
.text-text {
  color: #16274a;
  margin-bottom: 0;
  font-size: 26px;
}
.modal-body {
  margin: auto;
  text-align: center;
}
.img {
  width: 100px;
}
@media (max-width: 767.98px) {
}
</style>
